import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import VisibilitySensor from "react-visibility-sensor";
import img1 from "../../../assets/img/career/careerOne/selo-large2.webp";
import bg from "../../../assets/img/career/careerOne/careerOne-bg.webp";

const textKeys = ["career_one_text1", "career_one_text2", "career_one_text3"];

function CareerOne() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  return (
    <VisibilitySensor onChange={onChange} partialVisibility minTopValue={100}>
      <div className={`careerOne ${isVisible ? "visible" : ""}`}>
        <div className="img1">
          <img className={`${isVisible ? "visible" : ""}`} src={bg} alt="" />
        </div>
        <div className="careerText">
          <h1 className={`${isVisible ? "visible" : ""}`}>
            {t("career_one_title")} <span>{t("career_one_title_span")}</span>
          </h1>
          {textKeys.map((key) => (
            <p key={key} className={`${isVisible ? "visible" : ""}`}>
              {t(key)}
            </p>
          ))}
        </div>
      </div>
    </VisibilitySensor>
  );
}

export default CareerOne;
